import { createSlice } from "@reduxjs/toolkit";

const currentYear = new Date().getFullYear();

const benchmarkYearSlice = createSlice({
  name: "benchmarkYear",
  initialState: {
    year: currentYear,
  },
  reducers: {
    setBenchmarkYear: (state, action) => {
      state.year = action.payload;
    },
  },
});

export const { setBenchmarkYear } = benchmarkYearSlice.actions;
export default benchmarkYearSlice.reducer;
